import * as apicall from "../components/Apicall";

// "Branding & Offers": icons for the vendor's services / categories / service types,
// plus the vendor's own coupons. Images are sent as base64 data URLs and
// stored in S3 by the backend under vendors/<vendorId>/...

export const getBrandingCatalog = () => apicall.get("vendor_branding_catalog");

// level: "service" | "category" | "type"
// Folder the backend saves vendor-portal images under in S3: ezp/vendors/<vendorId>/...
export const STORAGE_PREFIX = "ezp";

export const saveIcon = ({ level, id, image }) =>
  apicall.post({ level, id, image, storage_prefix: STORAGE_PREFIX }, "vendor_branding_icon");

export const getCoupons = () => apicall.get("vendor_coupons");
// Coupons usable today (active, within dates) - for the new-booking Review step.
export const getBookingCoupons = () => apicall.get("vendor_booking_coupons");
export const saveCoupon = (coupon) => apicall.post(coupon, "vendor_coupon_save");
export const deleteCoupon = (id) => apicall.post({ id }, "vendor_coupon_delete");
